import { KnockGuideProvider } from "@knocklabs/react";
import { type ComponentProps, type ReactNode } from "react";

import { useRefetchKnockGuidesOnVisible } from "../hooks/useRefetchKnockGuidesOnVisible";

export type KnockGuideProviderWithRefetchProps = ComponentProps<typeof KnockGuideProvider>;

export function KnockGuideProviderWithRefetch(props: KnockGuideProviderWithRefetchProps) {
  const { children, ...knockGuideProps } = props;

  return (
    <KnockGuideProvider {...knockGuideProps}>
      <AutoRefetchGuides>{children}</AutoRefetchGuides>
    </KnockGuideProvider>
  );
}

/**
 * Internal component that calls the refetch hook. Must be rendered inside
 * KnockGuideProvider to access guide context.
 */
function AutoRefetchGuides(props: { children: ReactNode }) {
  const { children } = props;

  useRefetchKnockGuidesOnVisible();

  return children;
}
